var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"swipeup"},on:{"click":_vm.onClick}},[_c('swipe-up-cta')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }